// css =>
import "../../BaseStructure.css";
import Styled from "./mobileSubMenu.module.css";

function MobileSubMenu(props: { 
    subMenuOptions: string[];
    sunMenuWidthByPixel?: number;
    onItemClick?: (item: string, index: number) => void;
    selectedOptionIndex?: number;
}) {
    return(
        <div className={`row ${ Styled.SubMenuFrame } `} style={{ width: props.sunMenuWidthByPixel + "px", height: String(props.subMenuOptions.length * 70) + "px" }}>
            <br />
            {
                props.subMenuOptions.map((item, index) => {
                    return <div
                        className={`col-12 ${ props.selectedOptionIndex === index ? Styled.activeOption : "" } `}
                        key={ index }
                        onClick={() => props.onItemClick ? props.onItemClick(item, index) : {}}
                    >
                        <p>{ item }</p>
                    </div>
                })
            }
        </div>
    );
}

export default MobileSubMenu;
